import { type CardAuthorProps } from '3-components/Cards/CardArticle/CardArticle';
import type { ContentAreaItemModelSearch, ContentModelReference, ContentModelReferenceSearch, Maybe, PersonPage } from 'cms/cms-types';
import { resolveImageReferenceToImage } from './imageResolver';

export const resolveAuthorsToCardAuthors = (data: Maybe<Maybe<ContentAreaItemModelSearch[]>>): CardAuthorProps[] | undefined => {
    if (!data?.length) {
        return undefined;
    }

    return data.map(({ ContentLink }) => {
        const { Expanded } = ContentLink as ContentModelReferenceSearch;
        const { HeadshotImage, Name, Role, PreviewTitle } = Expanded as PersonPage;

        return {
            title: PreviewTitle || Name || '',
            subtitle: Role || '',
            img: resolveImageReferenceToImage(HeadshotImage as ContentModelReference, '?width=40'),
        };
    });
};
